export default __webpack_public_path__ + "static/media/Opay.791bb566.svg";